function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  strokeDasharray: "7,13",
  strokeLinecap: "square",
  d: "M.5-414.73v574.46"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.6 43.24h-.8V37.7a2.39 2.39 0 00-2.4-2.38h-1.6V20.24H36v15.07h-4.8V20.24h-4.8v15.07h-4.8V20.24h-4.8v15.07H12V20.24H7.2v15.07H5.6a2.39 2.39 0 00-2.4 2.38v5.55h-.8A2.39 2.39 0 000 45.62v1.59c0 .43.36.79.8.79h46.4a.8.8 0 00.8-.8v-1.58a2.39 2.39 0 00-2.4-2.38zm-5.6 0H8v-3.17h32v3.17zm7.23-32.01L25.52 2.24a4.84 4.84 0 00-3.04 0L.78 11.23a1.19 1.19 0 00-.78 1.1v2.76c0 .65.54 1.19 1.2 1.19h2v1.19c0 .65.54 1.19 1.2 1.19h39.2c.66 0 1.2-.54 1.2-1.2v-1.18h2c.66 0 1.2-.54 1.2-1.2v-2.74a1.19 1.19 0 00-.77-1.11zM4.8 13.9L24 6.76l19.2 7.14H4.8z"
}))));